import React from "react";

const SupportIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.96429 15.1H18.0357C18.6304 15.1 19.1 14.5759 19.1 13.95V6.25C19.1 6.00976 18.9191 5.8 18.6786 5.8C18.4381 5.8 18.2571 6.00976 18.2571 6.25V13.95C18.2571 14.0962 18.1501 14.2 18.0357 14.2H1.96429C1.84993 14.2 1.74286 14.0962 1.74286 13.95V4.6H18.6786C18.9191 4.6 19.1 4.39024 19.1 4.15V2.05C19.1 1.42406 18.6304 0.9 18.0357 0.9H1.96429C1.36957 0.9 0.9 1.42406 0.9 2.05C0.9 2.29024 1.08093 2.5 1.32143 2.5C1.56193 2.5 1.74286 2.29024 1.74286 2.05C1.74286 1.90384 1.84993 1.8 1.96429 1.8H18.0357C18.1501 1.8 18.2571 1.90384 18.2571 2.05V3.7H1.32143C1.08093 3.7 0.9 3.90976 0.9 4.15V13.95C0.9 14.5759 1.36957 15.1 1.96429 15.1Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M3.893 8.7999H4.53585C5.13057 8.7999 5.60014 8.27584 5.60014 7.6499V6.9499C5.60014 6.32396 5.13057 5.7999 4.53585 5.7999H3.893C3.29828 5.7999 2.82871 6.32396 2.82871 6.9499V7.6499C2.82871 8.27584 3.29828 8.7999 3.893 8.7999ZM3.67157 6.9499C3.67157 6.80374 3.77864 6.6999 3.893 6.6999H4.53585C4.65021 6.6999 4.75728 6.80374 4.75728 6.9499V7.6499C4.75728 7.79606 4.65021 7.8999 4.53585 7.8999H3.893C3.77864 7.8999 3.67157 7.79606 3.67157 7.6499V6.9499Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M3.25014 12.9997H5.17871C5.41921 12.9997 5.60014 12.7899 5.60014 12.5497C5.60014 12.3095 5.41921 12.0997 5.17871 12.0997H3.25014C3.00964 12.0997 2.82871 12.3095 2.82871 12.5497C2.82871 12.7899 3.00964 12.9997 3.25014 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M7.10756 12.9997H9.03613C9.27664 12.9997 9.45756 12.7899 9.45756 12.5497C9.45756 12.3095 9.27664 12.0997 9.03613 12.0997H7.10756C6.86706 12.0997 6.68613 12.3095 6.68613 12.5497C6.68613 12.7899 6.86706 12.9997 7.10756 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M10.964 12.9997H12.8926C13.1331 12.9997 13.314 12.7899 13.314 12.5497C13.314 12.3095 13.1331 12.0997 12.8926 12.0997H10.964C10.7235 12.0997 10.5426 12.3095 10.5426 12.5497C10.5426 12.7899 10.7235 12.9997 10.964 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M14.8214 12.9997H16.75C16.9905 12.9997 17.1714 12.7899 17.1714 12.5497C17.1714 12.3095 16.9905 12.0997 16.75 12.0997H14.8214C14.5809 12.0997 14.4 12.3095 14.4 12.5497C14.4 12.7899 14.5809 12.9997 14.8214 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M3.25014 10.9001H12.893C13.1335 10.9001 13.3144 10.6903 13.3144 10.4501C13.3144 10.2099 13.1335 10.0001 12.893 10.0001H3.25014C3.00964 10.0001 2.82871 10.2099 2.82871 10.4501C2.82871 10.6903 3.00964 10.9001 3.25014 10.9001Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M1.96429 15.1H18.0357C18.6304 15.1 19.1 14.5759 19.1 13.95V6.25C19.1 6.00976 18.9191 5.8 18.6786 5.8C18.4381 5.8 18.2571 6.00976 18.2571 6.25V13.95C18.2571 14.0962 18.1501 14.2 18.0357 14.2H1.96429C1.84993 14.2 1.74286 14.0962 1.74286 13.95V4.6H18.6786C18.9191 4.6 19.1 4.39024 19.1 4.15V2.05C19.1 1.42406 18.6304 0.9 18.0357 0.9H1.96429C1.36957 0.9 0.9 1.42406 0.9 2.05C0.9 2.29024 1.08093 2.5 1.32143 2.5C1.56193 2.5 1.74286 2.29024 1.74286 2.05C1.74286 1.90384 1.84993 1.8 1.96429 1.8H18.0357C18.1501 1.8 18.2571 1.90384 18.2571 2.05V3.7H1.32143C1.08093 3.7 0.9 3.90976 0.9 4.15V13.95C0.9 14.5759 1.36957 15.1 1.96429 15.1Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M3.893 8.7999H4.53585C5.13057 8.7999 5.60014 8.27584 5.60014 7.6499V6.9499C5.60014 6.32396 5.13057 5.7999 4.53585 5.7999H3.893C3.29828 5.7999 2.82871 6.32396 2.82871 6.9499V7.6499C2.82871 8.27584 3.29828 8.7999 3.893 8.7999ZM3.67157 6.9499C3.67157 6.80374 3.77864 6.6999 3.893 6.6999H4.53585C4.65021 6.6999 4.75728 6.80374 4.75728 6.9499V7.6499C4.75728 7.79606 4.65021 7.8999 4.53585 7.8999H3.893C3.77864 7.8999 3.67157 7.79606 3.67157 7.6499V6.9499Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M3.25014 12.9997H5.17871C5.41921 12.9997 5.60014 12.7899 5.60014 12.5497C5.60014 12.3095 5.41921 12.0997 5.17871 12.0997H3.25014C3.00964 12.0997 2.82871 12.3095 2.82871 12.5497C2.82871 12.7899 3.00964 12.9997 3.25014 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M7.10756 12.9997H9.03613C9.27664 12.9997 9.45756 12.7899 9.45756 12.5497C9.45756 12.3095 9.27664 12.0997 9.03613 12.0997H7.10756C6.86706 12.0997 6.68613 12.3095 6.68613 12.5497C6.68613 12.7899 6.86706 12.9997 7.10756 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M10.964 12.9997H12.8926C13.1331 12.9997 13.314 12.7899 13.314 12.5497C13.314 12.3095 13.1331 12.0997 12.8926 12.0997H10.964C10.7235 12.0997 10.5426 12.3095 10.5426 12.5497C10.5426 12.7899 10.7235 12.9997 10.964 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M14.8214 12.9997H16.75C16.9905 12.9997 17.1714 12.7899 17.1714 12.5497C17.1714 12.3095 16.9905 12.0997 16.75 12.0997H14.8214C14.5809 12.0997 14.4 12.3095 14.4 12.5497C14.4 12.7899 14.5809 12.9997 14.8214 12.9997Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
      <path
        d="M3.25014 10.9001H12.893C13.1335 10.9001 13.3144 10.6903 13.3144 10.4501C13.3144 10.2099 13.1335 10.0001 12.893 10.0001H3.25014C3.00964 10.0001 2.82871 10.2099 2.82871 10.4501C2.82871 10.6903 3.00964 10.9001 3.25014 10.9001Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default SupportIcon;
